import updateItemLanguageAction from '../actions/updateItemLanguageAction';
import getStampedLanguage from '../utils/getStampedLanguage';
import { ClientItem } from 'owa-mail-store';
import { mutator } from 'satcheljs';

export default mutator(updateItemLanguageAction, actionMessage => {
    // While we are here, if needed, parse the language and store it on the item.
    const item: ClientItem = actionMessage.item;
    item.stampedLanguage = getStampedLanguage(item);
});
